export const excelFileExtensions = ['.xlsx', '.xls'];
export const excelMimeTypes = [
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/vnd.ms-excel',
];
export const acceptedExcelFileExtensions = [...excelFileExtensions, ...excelMimeTypes].join(', ');
